<template>
  <div>
    <base-title-bar-scroll-page ref="container" :back="true" title="康复知识" @onBackClick="goBack">
      <div class="article-detail-container">
        <div v-if="loading" class="loading-container">
          <van-skeleton :row="8" />
        </div>
        
        <div v-else-if="article" class="article-content">
          <!-- 文章头部 -->
          <div class="article-header">
            <h1 class="article-title">{{ article.title }}</h1>
            <div class="article-meta">
              <span class="article-category">{{ article.category }}</span>
              <span class="article-date">{{ article.date }}</span>
            </div>
          </div>

          <!-- 文章封面 -->
          <div class="article-image" v-if="article.image">
            <img :src="article.image" :alt="article.title">
          </div>

          <!-- 文章摘要 -->
          <div class="article-summary" v-if="article.summary">
            <div class="summary-title">文章摘要</div>
            <p>{{ article.summary }}</p>
          </div>

          <!-- 文章内容 -->
          <div class="article-body" v-html="article.content"></div>

          <!-- 相关推荐 -->
          <div class="related-articles" v-if="relatedArticles.length > 0">
            <div class="related-title">相关阅读</div>
            <div class="related-list">
              <div class="related-item" 
                   v-for="related in relatedArticles" 
                   :key="related.id"
                   @click="goToRelated(related.id)">
                <div class="related-image" v-if="related.image">
                  <img :src="related.image" :alt="related.title">
                </div>
                <div class="related-content">
                  <h4>{{ related.title }}</h4>
                  <p>{{ related.summary }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-else class="error-container">
          <van-empty image="error" description="文章加载失败" />
          <van-button type="primary" @click="loadArticle">重新加载</van-button>
        </div>
      </div>
    </base-title-bar-scroll-page>
  </div>
</template>

<script>
import BaseTitleBarScrollPage from '@/h5/doucan/components/BaseTitleBarScrollPage.vue'
import { Skeleton, Empty } from 'vant'
import { articlesWithContent, getArticleById, categories } from './articlesData'

export default {
  name: 'ShunyiArticleDetailPage',
  components: {
    BaseTitleBarScrollPage,
    'van-skeleton': Skeleton,
    'van-empty': Empty
  },
  data() {
    return {
      loading: true,
      article: null,
      articleId: '',
      relatedArticles: [],
      categories: categories
    }
  },
  mounted() {
    this.articleId = this.$route.query.id
    this.loadArticle()
    this.hideLoading()
  },
  methods: {
    hideLoading() {
      this.$refs.container.stopLoading()
    },
    loadArticle() {
      this.loading = true
      
      // 模拟加载延迟
      setTimeout(() => {
        this.article = getArticleById(this.articleId)
        if (this.article) {
          // 使用categoryLabel显示
          this.article.category = this.article.categoryLabel || this.article.category
        }
        this.loadRelatedArticles()
        this.loading = false
      }, 500)
    },
    loadRelatedArticles() {
      // 获取同分类的相关文章（排除当前文章）
      if (this.article && this.article.category) {
        const categoryArticles = articlesWithContent.filter(
          article => article.categoryLabel === this.article.category && article.id !== this.articleId
        )
        this.relatedArticles = categoryArticles.slice(0, 3)
      }
    },
    goBack() {
      this.$router.go(-1)
    },
    goToRelated(id) {
      this.$router.push({
        path: '/shunyi/article/detail',
        query: { id }
      })
    }
  },
  watch: {
    '$route.query.id'(newId) {
      if (newId !== this.articleId) {
        this.articleId = newId
        this.loadArticle()
      }
    }
  }
}
</script>

<style scoped>
.article-detail-container {
  background: white;
  min-height: 100vh;
}

.loading-container {
  padding: 16px;
}

.article-content {
  padding: 0;
}

.article-header {
  padding: 20px 16px;
  background: linear-gradient(135deg, #1976D2 0%, #42A5F5 100%);
  color: white;
}

.article-title {
  font-size: 24px;
  font-weight: 700;
  line-height: 1.3;
  margin: 0 0 12px 0;
}

.article-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  opacity: 0.9;
}

.article-category {
  background: rgba(255, 255, 255, 0.2);
  padding: 4px 8px;
  border-radius: 12px;
  font-weight: 500;
}

.article-image {
  width: 100%;
  height: 240px;
  overflow: hidden;
}

.article-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.article-summary {
  padding: 16px;
  background: #f8f9fa;
  margin: 0;
}

.summary-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.article-summary p {
  font-size: 14px;
  line-height: 1.6;
  color: #666;
  margin: 0;
}

.article-body {
  padding: 20px 16px;
  font-size: 16px;
  line-height: 1.8;
  color: #333;
}

.article-body h2 {
  font-size: 20px;
  font-weight: 600;
  color: #1976D2;
  margin: 24px 0 16px 0;
  padding-bottom: 8px;
  border-bottom: 2px solid #E3F2FD;
}

.article-body h3 {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 20px 0 12px 0;
}

.article-body h4 {
  font-size: 16px;
  font-weight: 600;
  color: #555;
  margin: 16px 0 10px 0;
}

.article-body p {
  margin: 12px 0;
  text-align: justify;
}

.article-body ul,
.article-body ol {
  margin: 12px 0;
  padding-left: 24px;
}

.article-body li {
  margin: 8px 0;
  line-height: 1.8;
}

.article-body strong {
  color: #1976D2;
  font-weight: 600;
}

.article-body .conclusion,
.article-body .expert-reminder,
.article-body .action-tips {
  background: #E3F2FD;
  padding: 16px;
  border-radius: 8px;
  margin: 20px 0;
  border-left: 4px solid #1976D2;
}

.article-body .conclusion h2,
.article-body .expert-reminder h2,
.article-body .action-tips h3 {
  color: #1976D2;
  margin-top: 0;
  font-size: 18px;
  border-bottom: none;
  padding-bottom: 0;
}

.related-articles {
  padding: 20px 16px;
  background: #f8f9fa;
  margin-top: 30px;
}

.related-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
  padding-left: 12px;
  border-left: 4px solid #1976D2;
}

.related-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.related-item {
  display: flex;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  transition: transform 0.2s;
}

.related-item:active {
  transform: scale(0.98);
}

.related-image {
  width: 100px;
  height: 100px;
  flex-shrink: 0;
  overflow: hidden;
  background: #f0f0f0;
}

.related-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.related-content {
  flex: 1;
  padding: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.related-content h4 {
  font-size: 15px;
  font-weight: 600;
  color: #333;
  margin: 0 0 8px 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.related-content p {
  font-size: 13px;
  color: #666;
  line-height: 1.5;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.error-container {
  padding: 60px 16px;
  text-align: center;
}

/* 响应式设计 */
@media (max-width: 375px) {
  .article-header {
    padding: 16px 12px;
  }
  
  .article-title {
    font-size: 20px;
  }
  
  .article-body {
    padding: 16px 12px;
    font-size: 15px;
  }
  
  .article-body h2 {
    font-size: 18px;
  }
  
  .related-image {
    width: 80px;
    height: 80px;
  }
}

@media (min-width: 414px) {
  .article-image {
    height: 260px;
  }
  
  .article-title {
    font-size: 26px;
  }
}
</style>
